import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { IconModal } from '@modules/modal/enums/icon-modal.enum';

interface Actions {
  main: string;
  secondary: string;
}
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ModalComponent {
  icon!: IconModal;
  titleModal!: string;
  showActions: boolean = false;
  textActions!: Actions;
  addPaddingIcon: boolean = false;

  @Input() text!: string;

  @Input() set title(title: string) {
    this.titleModal = title;
    if (title) {
      this.addPaddingIcon = true;
    }
  }

  @Input() set actions(actions: Actions) {
    if (actions) {
      this.showActions = true;
      this.textActions = actions;
    }
  }
  @Input() set iconName(icon: string) {
    this.icon = icon as IconModal;
  }

  @Output() clickActionMain: EventEmitter<any> = new EventEmitter();
  @Output() clickActionSecondary: EventEmitter<any> = new EventEmitter();
  @Output() clickClose: EventEmitter<any> = new EventEmitter();

  slotChange($event) {
    const assigned = $event.target.assignedNodes();
    if (assigned.length > 0) {
      this.showActions = false;
    }
  }

  onClickMainButton() {
    this.clickActionMain.emit();
  }

  onClickSecondaryButton() {
    this.clickActionSecondary.emit();
  }

  onClickClose() {
    this.clickClose.emit();
  }

  get Type(): typeof IconModal {
    return IconModal;
  }
}
